const MONTHS = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];

const DatePickerHeader = ({
  month,
  year,
  viewMode,
  onPrev,
  onNext,
  onToggleView,
}) => {
  return (
    <div className="dp-header">
      <button
        className="dp-nav-btn"
        type="button"
        onClick={onPrev}
        aria-label="Anterior"
      >
        ‹
      </button>

      <div className="dp-header-center">
        <button className="dp-view-toggle" type="button" onClick={onToggleView}>
          {viewMode === "days"
            ? `${MONTHS[month]} ${year}`
            : viewMode === "months"
              ? year
              : "Año"}
        </button>
      </div>

      <button
        className="dp-nav-btn"
        type="button"
        onClick={onNext}
        aria-label="Siguiente"
      >
        ›
      </button>
    </div>
  );
};

export default DatePickerHeader;
